import { makeStyles } from 'tss-react/mui';

const useStylesExpansionGroupWidget: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  expansionGroupWidget: {
    marginTop: '0 !important',
    marginBottom: '10px !important',
    '& > div:first-of-type': {
      padding: '0 18px 0 12px',
      [theme.breakpoints.down('md')]: {
        padding: '0 16px',
      },
    },
  },
  expansionGroupWidgetExpanded: {
    marginBottom: '20px !important',
  },
}));

export default useStylesExpansionGroupWidget;
